/**
 * 拓扑插件-全局头部按钮相关操作mixins函数
 */

export default {
  data() {
    return {
      // 显示侧边栏
      showAside: true,
      // 显示属性栏
      showAttribute: false,
      // 选中激活状态
      selectedActive: true,
      // 连线激活状态
      joinLineActive: false,
      // 拓扑ID
      topologyId: '-1'
    };
  },
  methods: {

  }
};
